<template>
  <div class="col-7 progressInfoContainer">
    <div class="prev-progressContainer">
      <div class="backButton">
        <a v-if="prevLink" class="prevButton" @click="backButton()"></a>
      </div>
      <div class="progressHolder">
        <p class="testPersent">{{ calcedPercent * questionProgressdata }}%</p>
        <img src="../../assets/images/progress/ProgressBar.png">
        <img v-for="(steps, index) in questionProgressdata" :key="index + '-progress'" class="progressStep" :style="{left: 'calc(17% + (7.55% * ' + index + '))'}" src="../../assets/images/progress/progress.png">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['prevLink'],
  data() {
    return {
      calcedWidth: 0,
      calcedPercent: 10
    }
  },
  mounted () {
    if (this.questionProgressdata == 0 ) {
      this.$router.push('/one')
    }
    
  },
  computed: {
    questionProgressdata () {
      return this.$store.getters.StoreQuestionData.total
    }
  },
  methods: {
    backButton () {
      if (this.$route.query.replay) {
        this.$router.push('/result?replay=true')
      } else {
        this.$router.push('/' + this.prevLink)
      }
    }
  }
}
</script>

<style>
.progressStep {
  position: absolute;
}
</style>

